import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-shell',
  templateUrl: './footer-shell.component.html',
  styleUrls: ['./footer-shell.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterShellComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
